import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { CommonServiesService } from 'src/app/services/common-servies.service';
import { NotificationService } from 'src/app/services/notification.service';
@Component({
  selector: 'app-request-form',
  templateUrl: './request-form.component.html',
  styleUrls: ['./request-form.component.scss']
})
export class RequestFormComponent implements OnInit {
  contactForm: FormGroup;
  isButtonDisable: boolean = false;
  utmSource: string;
  timer: number = 0;
  @Input() courseId!: number;
  @Input() lpuCourseRegistrationId!: number;
  constructor(private fb: FormBuilder, private commonservice: CommonServiesService,
    private notifyService: NotificationService) {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$")
      ]],
      number: ['', [Validators.required, Validators.pattern("^[0-9]{10}$")]],
      collegeRegistrationNumber: ['', Validators.required]
    });
  }

  ngOnInit(): void {
  }

  requestCallBack() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched(); // Mark all fields as touched to show validation errors
      return;
    }

    const data = {
      lpuCourseRegistrationId: this.lpuCourseRegistrationId,
      courseId: this.courseId,
      studentName: this.contactForm.value.name,
      email: this.contactForm.value.email,
      mobile: this.contactForm.value.number,
      rollNumber: this.contactForm.value.collegeRegistrationNumber
    };

    this.isButtonDisable = true;
    this.timer = 30; // Set the timer duration
    const timerInterval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        this.isButtonDisable = false;
        clearInterval(timerInterval);
      }
    }, 1000);

    this.notifyService.showSuccess("Enquiry registered successfully! Someone from AlgoTutor will contact you soon.");
    this.commonservice.createOrUpdateLPUCourseRegistration(data).subscribe(
      res => { },
      err => {
        console.log(err);
        this.isButtonDisable = false;
        this.notifyService.showError("Something went wrong! Please try again later.");
      }
    );

    this.contactForm.reset(); // Reset form after successful submission
  }


  selectCourseId(courseId) {
    this.selectCourseId = courseId;
  }

  toClearFormValue(formValue) {
    formValue.name = '';
  }
}
